const view = "dashboard";

export const dashboard = {
  view,
  monosite: `${view}/monosite`,
  multisite: `${view}/multisite`,
  missingInfos: {
    missingDsoSubscription: {
      button: `${view}/missing-infos/missing-dso-subscription/button`,
      dialog: {
        component: `${view}/missing-infos/missing-dso-subscription/dialog`,
        title: `${view}/missing-infos/missing-dso-subscription/dialog/title`,
        subtitle: `${view}/missing-infos/missing-dso-subscription/dialog/subtitle`,
        content: `${view}/missing-infos/missing-dso-subscription/dialog/content`,
        contactButton: `${view}/missing-infos/missing-dso-subscription/dialog/contact-button`,
        laterButton: `${view}/missing-infos/missing-dso-subscription/dialog/later-button`,
      },
    },
    mono: {
      sitesManagementLink: `${view}/missing-infos/mono/site-management-link`,
      missingSurfaceAreaButton: `${view}/missing-infos/mono/missing-site-surface-area/button`,
    },
    multi: {
      missingSurfaceArea: {
        button: `${view}/missing-infos/multi/missing-site-surface-area/button`,
        dialog: `${view}/missing-infos/multi/missing-site-surface-area/dialog`,
        siteLink: `${view}/missing-infos/multi/missing-site-surface-area/site-link`,
        siteBadge: `${view}/missing-infos/multi/missing-site-surface-area/site-badge`,
        siteName: `${view}/missing-infos/multi/missing-site-surface-area/site-name`,
      },
    },
  },
  consumptionHighVariation: {
    dialog: `${view}/consumption-high-variation/dialog`,
    button: `${view}/consumption-high-variation/button`,
  },
  card: {
    cardInfosButton: `${view}/card/card-infos-button`,
    cardInfosDialog: `${view}/card/card-infos-dialog`,
  },
  dialog: {
    headerCloseButton: `${view}/dialog/header-close-button`,
    footerCloseButton: `${view}/dialog/footer-close-button`,
  },
  insights: {
    totalDsoConsumptionCard: `${view}/insights/total-dso-consumption-card`,
    totalDevicesConsumptionCard: `${view}/insights/total-devices-consumption-card`,
    avgConsumptionPerM2Card: `${view}/insights/average-consumption-per-m2-card`,
    consumptionEvolutionCard: `${view}/insights/consumption-evolution-card`,
    estimatedConsumptionCostCard: `${view}/insights/estimated-consumption-cost-card`,
  },
  charts: {
    consumptionEvolutionChart: `${view}/chart/consumption-evolution-chart`,
    consumptionPerM2Chart: `${view}/chart/consumption-per-m2-chart`,
    consumptionComparisonChart: `${view}/chart/consumption-comparison-chart`,
    consumptionDistributionPerDeviceTypesChart: `${view}/chart/consumption-distribution-per-device-types-chart`,
    consumptionHeatmap: `${view}/chart/consumption-heatmap`,
  },
  podiums: {
    lessEnergyConsummingPodium: `${view}/podium/less-energy-consumming-podium`,
    mostEnergyConsummingPodium: `${view}/podium/most-energy-consumming-podium`,
    highestConsumptionIncreasePodium: `${view}/podium/highest-consumption-increase-podium`,
    highestConsumptionDecreasePodium: `${view}/podium/highest-consumption-decrease-podium`,
  },
  links: {
    totalDsoConsumptionLink: `${view}/link/total-dso-consumption-link`,
    devicesConsumptionLink: `${view}/link/total-devices-consumption-link`,
    sitesManagementLink: `${view}/link/sites-management-link`,
  },
  buttons: {
    contactVoltalisBtn: `${view}/button/contact-voltalis-button`,
  },
  selectPerimeter: {
    button: `${view}/select-perimeter-button`,
    dialog: {
      component: `${view}/select-perimeter-dialog`,
      cancelButton: `${view}/select-perimeter-dialog/cancel-button`,
      submitButton: `${view}/select-perimeter-dialog/submit-button`,
    },
  },
};
